import apiClient from '@/utils/api-client-without-base-url';

const suffixEndpoint = '/users';

export default {
  getAll: () => apiClient.get(suffixEndpoint),
  getLoggedUser: () => apiClient.get(suffixEndpoint + "/logged-user"),
  getAllPermissions: () => apiClient.get(suffixEndpoint + "/all-permissions"),
  get: id => {
    return apiClient.get(`${suffixEndpoint}/${id}`);
  },
  create: data => {
    return apiClient.post(suffixEndpoint, data);
  },
  saveConfigSale: data => {
    return apiClient.put(`${suffixEndpoint}/sale-config`, data);
  },
  saveProductConfig: data => {
    return apiClient.put(`${suffixEndpoint}/product-config`, data);
  },
  edit: data => {
    const { id: categoryId } = data;
    
    delete data["id"];

    return apiClient.put(`${suffixEndpoint}/${categoryId}`, data);
  },
  delete: id => {
    return apiClient.delete(`${suffixEndpoint}/${id}`);
  },
};
